import InlineColor from "../../../../src/components/InlineColor.jsx";
import flexoverlay from "../../../../assets/images/docs/elements/flexoverlay.png";
import * as React from 'react';
export default {
  InlineColor,
  flexoverlay,
  React
};